<template>
  <div class="card">
    <div class="title-container">{{ text.title }}</div>
    <div class="text-container">
      <img src="@/assets/images/svg/icon-chat.svg" alt="chat-icon" class="chat-icon" />
      <p>{{ text.contact }}</p>
    </div>
    <button @click="launchChat">{{ text.start }}</button>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n-composable'
import { openLandbotChat } from '@/components/landbot/composables/useLandbot'
import { TrackerEvents, trackEvent } from '@/plugins/tracker'

// TRANSLATIONS
const { t } = useI18n()
const text = {
  title: t('components.dialog.support_service.chat_online.title'),
  start: t('components.dialog.support_service.chat_online.start'),
  contact: t('components.dialog.support_service.chat_online.contact')
}

// EVENTS
const emits = defineEmits(['close'])

const closeModal = () => {
  emits('close')
}

// METHODS
const launchChat = () => {
  openLandbotChat()
  trackEvent(TrackerEvents.LAUNCH_LANDBOT)
  closeModal()
}
</script>

<style lang="scss" scoped>
.card {
  display: flex;
  padding: $spacing-sm;
  flex-direction: column;
  align-items: center;
  gap: $spacing-sm;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: $cornerRadius-md;
  border: 1px solid $main-300;
  background: $neutral-white-000;

  .title-container {
    @include milano-bold-24;
    padding: $spacing-xs;
    color: $highlight-200;
    text-align: center;
  }

  .text-container {
    @include milano-regular-16;
    display: flex;
    padding: $spacing-xs;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 8px;
    align-self: stretch;
    color: $neutral-grey-800;
    margin-top: 15px;

    .chat-icon {
      margin-bottom: 8px;
    }

    p {
      margin: 0;
    }
  }

  button {
    @include milano-bold-16;
    display: flex;
    height: 37px;
    padding: $spacing-xs $spacing-sm;
    justify-content: center;
    align-items: center;
    color: $main-1000;
  }
}
</style>
